import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ReportService } from "src/app/services/report.service";
import { QueryExecutorDetailModel } from "src/app/model/QueryExecutorDetailModel";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-secure-query-executor",
  templateUrl: "./query-executor.component.html",
  styleUrls: ["./query-executor.component.scss"],
})
export class QueryExecutorComponent implements OnInit {
    isLoading: boolean = false;
    queryExecutorKey: number;
    queryExecutorDetail: QueryExecutorDetailModel;
    submitDisabled: boolean;
    pageMode: string;
    boards: {[key: number]: string};
    form: FormGroup = new FormGroup({});
    
    constructor(private router: Router, private route: ActivatedRoute, 
        private reportService: ReportService) { }
    
    ngOnInit(): void { 
        this.reportService
        .initQueryExecutorForm()
        .subscribe((data: any) => {
            if(data.status === 'SUCCESS') {
                this.boards = data.boards;
                this.route.params.subscribe((params: Params) => {
                    this.queryExecutorKey = +params["key"];      
                    console.log('this.queryExecutorKey', this.queryExecutorKey);
                    if(this.queryExecutorKey) {
                        this.reportService
                        .getQueryExecutorBykey(this.queryExecutorKey)
                        .subscribe((data1: any) => {
                            console.log(data1);
                            this.queryExecutorDetail = data1;
                            this.pageMode = "Edit";

                            let columnList: {columnName: string, columnWidth: number}[] = [];

                            let columnNames = this.queryExecutorDetail.columnNames.split(',');
                            let columnWidths = this.queryExecutorDetail.columnWidths.split(',');

                            for(let t = 0; t < columnWidths.length; t++) {
                                columnList.push({
                                    columnName: columnNames[t],
                                    columnWidth: +columnWidths[t],
                                });
                            }

                            this.form.patchValue({
                                boardKey: this.queryExecutorDetail.boardKey,
                                reportName: this.queryExecutorDetail.reportName,
                                reportDescription: this.queryExecutorDetail.reportDescription,
                                query: this.queryExecutorDetail.query,
                            });

                            let columns: FormArray = this.form.get('columns') as FormArray;

                            columnList.forEach(obj => {
                                columns.push(new FormGroup({
                                    columnName: new FormControl(obj.columnName, [Validators.required, Validators.pattern(/^[A-Za-z\s]*$/)]),
                                    columnWidth: new FormControl(obj.columnWidth, [Validators.required, Validators.pattern(/^[0-9]+$/)])
                                }));
                            });
                        });
                    }
                    else {
                        this.pageMode = "Add";
                    }
                });
            }
            else {
                this.reportService.errorToast(data.errorMessage, 5*1000);
            }
        });
        this.form = new FormGroup({
            boardKey: new FormControl(null),
            reportName: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
            reportDescription: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
            query: new FormControl(null, [Validators.required]),
            columns: new FormArray([])
        });
    }
    
    onSubmit() {
        if (this.form.valid) {
          if(this.pageMode === 'Add') {
            this.save();
          }
          else {
            this.update();
          }
        } 
        else {
          this.submitDisabled = false;
        }
    }
    
    async save() {
        this.reportService
        .saveQueryExecutor({
            boardKey: +this.form.value.boardKey?.key,
            reportName: this.form.value.reportName,
            reportDescription: this.form.value.reportDescription,
            query: this.form.value.query,
            columnNames: this.form.value.columns.map(c => c.columnName.replaceAll(" ", "")).join(","),
            columnWidths: this.form.value.columns.map(c => c.columnWidth).join(","),
        })
        .subscribe((data: any) => {
            if(data.status === 'SUCCESS') {
                this.reportService.successToast("Saved Successfully");
                this.router.navigate(["/secure", "query-executor-list"]);
            }
            else {
                this.submitDisabled = false;
                this.reportService.errorToast(data.errorMessage);
            }
        }, error => {
            this.submitDisabled = false;
            console.log(error);
            this.reportService.errorToast(error.error.errorMessage, 5*1000);
        });  
    }
    
    async update() {
        this.reportService
        .updateQueryExecutor(this.queryExecutorKey, {
            boardKey: +this.form.value.boardKey?.key,
            reportName: this.form.value.reportName,
            reportDescription: this.form.value.reportDescription,
            query: this.form.value.query,
            columnNames: this.form.value.columns.map(c => c.columnName.replaceAll(" ", "")).join(","),
            columnWidths: this.form.value.columns.map(c => c.columnWidth).join(","),
        }).subscribe((data: any) => {
            if(data.status === 'SUCCESS') {
            this.reportService.successToast("Updated Successfully");
            this.router.navigate(["/secure", "query-executor-list"]);
            }
            else {
            this.submitDisabled = false;
            this.reportService.errorToast(data.errorMessage);
            }
        }, error => {
            this.submitDisabled = false;
            console.log(error);
            this.reportService.errorToast(error.error.errorMessage, 5*1000);
        });    
    }

    addColumn() {
        let columns: FormArray = this.form.get('columns') as FormArray;
        columns.push(new FormGroup({
            columnName: new FormControl(null, Validators.required),
            columnWidth: new FormControl(null, Validators.required),
        }));
    }

    deleteColumn(i: number) {
        let columns: FormArray = this.form.get('columns') as FormArray;
        columns.removeAt(i);
    }

    get columns() {
        return this.form.get('columns')['controls'];
    }

    showBDD(o1: any, o2: any) {    
        if(o1 && o2 && o1.key == o2.key) {
          return o1.value;
        }
        else {
          return "";
        }
    }
}